/*
 * @Author: edvardchen
 * @Date:   2016-11-18 12:04:19
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:34:25
 */

import _ from 'lodash';
import qs from 'query-string';
import { isomorphicConfig } from '../utility/';
import { post, get } from './fetch';
import { getQIMEI36, promiseTimeout, getAndroidID, getOAID } from '../utility/C4PV';
import ReportRecommend from '../utility/reportRecommend';
const host = _.get(isomorphicConfig, 'crStatHost');
export { host };
export const reportAccessOld = (data) => get(`${host}?${qs.stringify(data)}`);

export const reportAccess = async (logData, logType = 'qb_statistic') => {
  const qimei36 = await promiseTimeout(getQIMEI36);
  const oaid = await promiseTimeout(getOAID);
  const androidId = await promiseTimeout(getAndroidID);
  const logParams = {
    F25: `qimei36=${qimei36};oaid=${oaid};android_id=${androidId}`,
    ...logData,
  };
  post(`${host}/log/report`, {
    body: {
      ...logParams,
      logType,
      oaid,
      android_id: androidId,
    },
  });
};

/**
 * 上报 access pv
 * @param  {String}  options.contentId
 * @param  {String}  options.url          原网址
 * @param  {String}  options.tagId
 * @param  {String}  options.tabId
 * @param  {String}  options.extData      策略信息
 * @param  {String}  options.ch           渠道号
 * @param  {String}  options.innerCh      内部渠道号
 * @param  {String}  options.fromId
 * @param  {Number}  options.position
 * @param  {String}  options.businessType wechat,coolread,correlate
 * @param  {String}  options.business     wechat,coolread,tag
 * @return {Promise}
 */
const __reportAccess = async ({
  contentId,
  url,
  tagId,
  tabId,
  extData,
  ch,
  innerCh,
  fromId,
  position,
  viewType,
  businessType,
  pid,
  dataSrc,
  subjectId,
  zimeitiId,
  data_type,
  ctrid,
  isVideo,
  busi_type,
  business = 'coolread',
  auto = 0,
}) => {
  const params = qs.stringify({
    oriUrl: url,
    contentId,
    channel: ch,
    innerCh,
    extData,
    businessId: business,
    businessType: businessType || business,
    tagId,
    tabId,
    fromId,
    position,
    logType: 'access',
    viewType,
  });
  get(`${host}?${params}`);

  const extDataObj = qs.parse(extData);
  const qimei36 = await promiseTimeout(getQIMEI36);
  const oaid = await promiseTimeout(getOAID);
  const androidId = await promiseTimeout(getAndroidID);
  post(`${host}/log/report`, {
    body: {
      logType: 'qb_statistic',
      F7: ch,
      F8: innerCh,

      F9: pid,
      F11: data_type,
      F10: busi_type,
      F12: ctrid,

      F13: extDataObj.sGrayPlatFormModelId,
      F14: extDataObj.sFirstStrategy,
      F15: extDataObj.sModelId,
      F16: extDataObj.sStrategyId,
      F10: isVideo ? 2 : 1, // 日志类型（新闻、视频、直播）
      F25: `qimei36=${qimei36};oaid=${oaid};android_id=${androidId}`,
      F26: contentId,
      F27: dataSrc,
      F28: subjectId,
      F29: zimeitiId,
      F30: isVideo ? '' : 1, // 普通文章、图集
      F32: url,
      oaid,
      android_id: androidId,
      F48: auto,
    },
  });
};

/**
 * 上报文章消费
 * @param  {String}  options.docId
 * @param  {String}  options.ext        策略信息，列表返回的
 * @param  {String}  options.extenddata 策略信息，url带进来的
 * @param  {String}  options.extData    策略信息
 * @return {Promise}
 */
export function reportArticlePV({ docId, ext, extenddata, extData, ...args }) {
  return __reportAccess({
    ...args,
    extData: ext || extenddata || extData,
    viewType: 'article',
    contentId: docId,
  });
}

/**
 * 上报视频消费
 * @param  {String}    options.vid
 * @return {Promise}
 */
export function reportVideoPV({ vid, ...args }) {
  return __reportAccess({
    ...args,
    viewType: 'video',
    contentId: vid,
    dataSrc: 1, // F27 视频点击
    pid: 102,
    ctrid: 1,
    isVideo: true,
  });
}

export function report4QEH(data) {
  return post(`${host}/log/report4omg`, {
    body: {
      ...data,
      logType: 'om_userAction',
    },
  });
}

// const expKey = 'news_exp_cache';
let exposedToReport = [];
const DELAY = 500;
const __reportExposed = _.throttle(
  async () => {
    // eslint-disable-next-line prefer-destructuring
    const first = exposedToReport[0];
    if (!first) {
      return;
    }
    const { ch, innerCh, pid, ctrid, data_type } = first;
    let grayInfo = '';
    const info = exposedToReport.map((item) => {
      const realext = item.extData || item.extenddata || item.extdata;
      const extObj = qs.parse(realext);
      grayInfo = item.sGrayPlatFormModelId || '';
      return [
        item.docId,
        1,
        extObj.sStrategyId,
        extObj.iBusinessId,
        extObj.sZimeitiId,
        extObj.sSubject,
        extObj.iContentType,
      ].join('##');
    });
    const qimei36 = await promiseTimeout(getQIMEI36);
    const oaid = await promiseTimeout(getOAID);
    const androidId = await promiseTimeout(getAndroidID);
    post(`${host}/log/report`, {
      body: {
        logType: 'qb_exposure',
        F7: ch,
        F8: innerCh,
        F9: pid,
        F10: ctrid,
        F12: data_type,
        F13: 1,
        F14: 1,
        F15: info.join(';'),
        F16: grayInfo,
        F25: `qimei36=${qimei36};oaid=${oaid};android_id=${androidId}`,
        oaid,
        android_id: androidId,
      },
    });
    exposedToReport = [];
  },
  DELAY,
  { leading: false },
);
export function reportArticleExposure(data) {
  exposedToReport.push(data);
  __reportExposed();
}

export function reportToBackClk(params) {
  post(`${host}/log/report`, {
    body: params,
  });
}

export function reportYanPV(params, type) {
  const { docId = '', vid = '', ch = '', productId = 159, auto = 0 } = params;
  const query = qs.parse(window.location.href);
  const { extenddata } = query;
  const extData = qs.parse(extenddata) || {};
  const { sGrayPlatFormModelId } = extData;

  const extData2 = Object.assign(extData, {
    ch, // push的严口径文中视频默认001885
    dataSrc: 1,
    data_type: 3, // 3短视频
    action: type,
    sGrayPlatFormModelId,
    docId,
    senceId: 1, // 相关推荐
    productId,
    vid,
    auto, // 视频类型是否自动播放
  });
  ReportRecommend.qbTerminalExposure(extData2);
}
